import React from "react";
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';import AsyncPage from "./async";

export default [
  <DefaultConsumerLayout
    key="/consumer/features/ai-photo-fixer"
    exact
    path="/consumer/features/ai-photo-fixer"
    component={AsyncPage}
  />,
];